/* Adds the Track Your Order link to the design's own header and mobile menu,
   and to the footer. The page itself lives at /pages/track (template
   page.track + sections/cheeky-dad-track.liquid) — it was never missing, it
   just had no link pointing at it. */
(function(){
var HREF='/pages/track';
var LABEL='Track Order';

function addDesktop(){
var nav=document.getElementById('cd-nav');
if(!nav||nav.querySelector('[data-cd-track]'))return;
var cta=nav.querySelector('a[href="#shop"]:last-of-type');
var a=document.createElement('a');
a.setAttribute('data-cd-track','1');
a.href=HREF;
a.textContent=LABEL;
a.setAttribute('style','color:#f4e8c8; text-decoration:none; font-weight:600; font-size:15px; white-space:nowrap;');
var links=nav.querySelectorAll('a');
var last=links[links.length-1];
if(last&&last.getAttribute('href')==='#shop'){nav.insertBefore(a,last);}else{nav.appendChild(a);}
}

function addMobile(){
var mn=document.getElementById('cd-mnav');
if(!mn||mn.querySelector('[data-cd-track]'))return;
var a=document.createElement('a');
a.setAttribute('data-cd-track','1');
a.href=HREF;
a.textContent='Track Your Order';
a.setAttribute('style','color:#f4e8c8; text-decoration:none; font-weight:700; font-size:17px; padding:14px 0; border-top:1px solid #1c3a63;');
var links=mn.querySelectorAll('a');
var last=links[links.length-1];
if(last&&last.getAttribute('href')==='#shop'){mn.insertBefore(a,last);}else{mn.appendChild(a);}
}

function addFooter(){
var f=document.querySelector('#cd > footer');
if(!f||f.querySelector('[data-cd-track]'))return;
var row=f.firstElementChild;
if(!row)return;
var a=document.createElement('a');
a.setAttribute('data-cd-track','1');
a.href=HREF;
a.textContent='Track Your Order';
a.setAttribute('style','color:#f4e8c8; text-decoration:underline; font-weight:700; font-size:13px;');
row.appendChild(a);
}

function run(){addDesktop();addMobile();addFooter();}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',run);}else{run();}
setTimeout(run,400);
setTimeout(run,1200);
})();
